import { createContext } from 'react';
export var TabsContext = /*#__PURE__*/createContext({});